import { render } from "./ProductsBanner.vue?vue&type=template&id=228885af&scoped=true"
import script from "./ProductsBanner.vue?vue&type=script&lang=js"
export * from "./ProductsBanner.vue?vue&type=script&lang=js"

import "./ProductsBanner.vue?vue&type=style&index=0&id=228885af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228885af"]])

export default __exports__